import { DescLanguageDto, defaultDescLanguageDto } from 'src/dtos/descLanguage/descLanguageDto';

export interface SYS2020_R01Dto extends DescLanguageDto {
	inserted: boolean;
	isModified: boolean;
}

export const defaultSYS2020_R01Dto: SYS2020_R01Dto = {
	
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
  
	commentCd: '',
	description: '',
	lang01: '',
	lang02: '',
	lang03: '',
	lang04: '',
	lang05: '',
	lang06: '',
	lang07: '',
	lang08: '',
	lang09: '',
	lang10: '',
	lang11: '',
	lang12: '',
	lang13: '',
	lang14: '',
	lang15: '',
	remark: '',
  
	insertDt: new Date(),
	insertUser: '',
	insertForm: '',
	updateDt: new Date(),
	updateUser: '',
	updateForm: '',

	inserted: false,
	isModified: false,
};

export const LANG_COLUMN_HEADERS: Record<string, string> = {
	commentCd: '코드',
	description: '용도',
	lang01: '한글',
	lang02: '영어',
	lang03: '중국',
	lang04: '베트남',
	lang05: '태국',
	lang06: '네팔',
	lang07: '캄보디아',
	lang08: '인도네시아',
	lang09: '필리핀',
	lang10: '우즈베키스탄',
	lang11: '스리랑카',
	lang12: '몽골',
	lang13: '언어13',
	lang14: '언어14',
	lang15: '언어15',
};

export const LANG_FIELDS = [
	'lang01', 'lang02', 'lang03', 'lang04', 'lang05',
	'lang06', 'lang07', 'lang08', 'lang09', 'lang10',
	'lang11', 'lang12', 'lang13', 'lang14', 'lang15',
] as const;
